export enum ServiceType {
    DEPOSIT_BANK_ACCOUNT = 1,
    CREDIT_CARD_PAYMENT = 2,
}